import { render, staticRenderFns } from "./update-milestone.vue?vue&type=template&id=62ad2da5&"
import script from "./update-milestone.vue?vue&type=script&lang=js&"
export * from "./update-milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports